import React, { Component } from "react";
import { connect } from "react-redux";

import GameBoard from "../../components/SplitSecond/Game/GameBoard";
import { setGameBetUnlock, setGameFocusLinkIndex, addGamePoints, reduceGamePoints, setGameBet, setGameWonStatus, setGameLostStatus, resetGameStatus, setGameDataIndex, setGameRevealAllAnswersStatus, GAME_STATUS_REVEAL_ALL_ANSWERS, GAME_STATUS_HINT_CLICK, GAME_STATUS_AWARD_REWARD, setGamePoints, setGameStartStatus, setGameReplayStatus, GAME_STATUS_START, GAME_STATUS_WON, GAME_STATUS_LOST, setGameCorrectAnswerStatus, setGameIncorrectAnswerStatus, GAME_STATUS_CORRECT_ANSWER, GAME_STATUS_INCORRECT_ANSWER, GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK, setGameQuitStatus, setGameInactiveStatus, GAME_STATUS_QUIT, setIsAllowHintOnFocusLink, GAME_STATUS_INACTIVE, setGameActiveStatus, GAME_STATUS_ACTIVE } from "../../actions/game";
import { playSound, stopSound } from "../../utils/audio-helper";
import { saveGameStats, setJsonDataToStorage } from "../../utils/localStorage";

class GameContainer extends Component {
  constructor(props) {
    super(props);
    const self = this;

    self.state = {
      keyCode: null,
      typingInactivity: false,
      endGame: false,
      //ss game states
      questionIndex: 0,
      userGameStatus: {},
      qOpt: [],
      qOptUpdated: false,
      isQOptAllDone: false,
      isInactive: false,
      timerEnd: false,
      answerSet: []
    };

    this.handleTimerEndCallback = this.handleTimerEndCallback.bind(this);
    this.setQOptDone = this.setQOptDone.bind(this);
    this.checkWinCondition = this.checkWinCondition.bind(this);
    // this.handleLinkBlur = this.handleLinkBlur.bind(this);

    this.typingInactivityTimer = null;
  }

  delay(callback, delay) {
    return window.setTimeout(()=>{
      callback();
    }, delay);
  }

  // for updating chain game board properties
  revealLinkAnswer(index, statusCorrect=false) {
    const status = statusCorrect?'STATUS_CORRECT':'';
    this.setState({revealLinkValue:{type:'REVEAL_LINK_ANSWER', index, status}});
  }

  setInactivityTimer(delay=6000) {
    const self = this;

    self.typingInactivityTimer = window.setTimeout(()=>{
      self.setState({typingInactivity: true})
    }, delay);
  }

  clearInactivityTimer() {
    window.clearTimeout(this.typingInactivityTimer);
    this.setState({typingInactivity: false})
  }

  setGameResultStatus(delay=2000) {

    //advance game data index for next game
    this.delay(()=>{
      this.checkWinCondition();
    }, delay);
  }

  setEndGameStateWithDelay() {
    this.setState({endGame: true});
  }

  handleTimerEndCallback() {
    this.setGameResultStatus(0);
    this.setState({timerEnd: true})
  }

  checkQOptAllDone() {
    if (this.state.qOpt.filter(item=>!item.isDone).length === 0) {
      this.setState({isQOptAllDone:true});
    }
  }

  checkInactive() {
    if (this.state.qOpt.filter(item=>item.isDone).length === 0) {
      this.setState({isInactive: true});
      return true;
    }

    return false;
  }

  checkWinCondition() {
    // console.log('checkWinCondition');
    if (this.checkInactive()) {
      return;
    }

    if (this.state.isQOptAllDone || this.state.timerEnd) {
      if (this.state.qOpt.filter(item=>!item.isCorrect).length === 0) {
        this.props.setGameWonStatus();
        saveGameStats({GAME_STATUS:GAME_STATUS_WON})
        // console.log('setGameWonStatus');
      } else {
        this.props.setGameLostStatus();
        saveGameStats({GAME_STATUS:GAME_STATUS_LOST})
        // console.log('setGameLostStatus');
      }
    }
  }

  initGameData() {
    const 
      todayTime = (new Date()).setHours(0,0,0,0),
      getDateTime = dateStr=>(new Date(dateStr + ' 00:00:00')).getTime(),
      isDateFound = item=>{
        const dateTime = getDateTime(item.date),
          found = dateTime === todayTime;

        if (found) console.log('isDateFound', item.date, todayTime);

        return found;
      },
      getQIndex = ()=>{
          const foundIndex = this.props.gameData.findIndex(isDateFound),
            isFound = foundIndex !== -1;

        return isFound ? foundIndex : this.state.questionIndex;
      },
      questionIndex = getQIndex(),
      gameData = this.props.gameData[questionIndex],
      option = gameData.option,
      extraAnswer = gameData.extraAnswer,
      qOpt = option && option.map(item=>Object.assign(item,{isCorrect: false, isDone: false})),
      answerSet = option && option.reduce((pval, cval)=>{
        pval.push(cval.answer);
        return pval;
      }, []).concat(extraAnswer).sort((a, b) => 0.5 - Math.random());

    this.setState({
      questionIndex,
      qOpt,
      answerSet
    });
  }

  setQOptDone(ans, index) {
    const qOpt = [...this.state.qOpt];
    console.log('setQOptDone', ans, index, qOpt);

    qOpt[index].isDone = true;
    qOpt[index].isCorrect = qOpt[index].answer === ans;

    this.setState({qOpt, qOptUpdated: true});
  }

  componentDidMount() {
    const self = this,
    { questionIndex } = this.state,
    qExist = this.props.gameData.length > 0 && this.props.gameData[questionIndex];

    this.props.setGamePoints(5); // reset game points
    this.props.setGameStartStatus();

    window.addEventListener('keydown',(evt)=>{
      // console.log('keypress', evt, evt.code);
      self.setState({keyCode:evt.code || evt.key});
    });

    if (qExist) {
      this.initGameData();
    }
  }

  componentDidUpdate(prevProps, prevState) {

    // Set replay status
    if (this.props.gameStatus === GAME_STATUS_START && (prevProps.gameStatus === GAME_STATUS_WON || prevProps.gameStatus === GAME_STATUS_LOST)) {
      this.props.setGameReplayStatus();
    }

    // reset game status on correct and incorrect answers
    if ((this.props.gameStatus === GAME_STATUS_CORRECT_ANSWER || this.props.gameStatus === GAME_STATUS_INCORRECT_ANSWER) && prevProps.gameStatus === this.props.gameStatus) {
      this.props.resetGameStatus();
    }

    //Go to results page depending on game status
    if ((this.props.gameStatus === GAME_STATUS_WON || this.props.gameStatus === GAME_STATUS_LOST || this.props.gameStatus === GAME_STATUS_INACTIVE) && prevProps.gameStatus !== this.props.gameStatus) {
      this.props.transitionOut();
    }

    if (prevProps.gameDataIndex !== this.props.gameDataIndex) {
      this.setState({questionIndex: this.props.gameDataIndex});
    }

    if (prevProps.gameData.length !== this.props.gameData.length && this.props.gameData.length > 0) {
      this.initGameData();
    }

    if (this.state.qOptUpdated && this.state.qOptUpdated!==prevState.qOptUpdated) {
      this.checkQOptAllDone();
      this.props.setGameActiveStatus();
      this.setState({qOptUpdated: false});
    }

    // if (this.state.isInactive && !prevState.isInactive && this.state.timerEnd && !prevState.timerEnd) {
    if (this.state.isInactive && this.state.timerEnd) {
      this.props.setGameInactiveStatus();
    }
  }

  render() {
    // console.log('gameData', this.props.gameData);
    const {
        questionIndex,
        userGameStatus,
        qOpt,
        answerSet,
        isQOptAllDone
      } = this.state,
      {
        question,
        answer,
        extraAnswer,
        option
      } = 
      // {question: 'question?', answer: 'testing'}; 
    this.props.gameData.length > 0 && this.props.gameData[questionIndex];

    // console.log('questionIndex:', questionIndex, this.props.gameData[questionIndex], answer, answerSet);

    return (
      <GameBoard
        hasAnsweredCallback={(ans, nextQuestion=false)=>{
          console.log(ans, nextQuestion);
          const 
            tempAnswer = answer || answerSet[0],
            isCorrect = ans.answer.toUpperCase() === tempAnswer.toUpperCase(),
            qI = nextQuestion ? (questionIndex + 1): questionIndex,
            userGameStatus = (nextQuestion && {}) || Object.assign({}, ans, {isCorrect});

          console.log('hasAnsweredCallback', isCorrect);//ans, ans.answer.toUpperCase(), tempAnswer.toUpperCase());

          this.setState({
            questionIndex: qI, 
            userGameStatus
          });

          // this.props.setGamePoints(place);
          this.props.setGameDataIndex(qI);
        }}
        question={question}
        qOpt={qOpt}
        answer={answer || (answerSet && answerSet[0])}
        answerSet={answerSet}
        timerEndCallback={()=>{this.handleTimerEndCallback()}}
        userGameStatus={userGameStatus}
        setQOptDone={this.setQOptDone}
        isQOptAllDone={isQOptAllDone}
        checkWinCondition={this.checkWinCondition}
        // selectLinkIndex={this.props.focusLinkIndex}
        // betLocked={this.props.betLocked}
        // bet={this.props.bet}
        sounds={this.props.sounds}
      />
    );
  }
}

const mapStateToProps = state => ({
  sounds: state.audio.sounds,
  alternateWords: state.alternateWords,
  focusLinkIndex: state.game.focusLinkIndex,
  gameData: state.game.data,
  gameDataIndex: state.game.dataIndex,
  betLocked: state.game.betLocked,
  points: state.game.points,
  bet: state.game.bet,
  gameStatus: state.game.status,
  submissionResult: state.sweepstakes.submissionResult,
  submissionStatus: state.sweepstakes.submissionStatus,
});

const mapDispatchToProps = dispatch => ({
  setGameFocusLinkIndex: data=>{
    dispatch(setGameFocusLinkIndex(data));
  },
  setIsAllowHintOnFocusLink: data=>{
    dispatch(setIsAllowHintOnFocusLink(data));
  },
  setGameBet: data=>{
    dispatch(setGameBet(data));
  },
  setGameBetUnlock: ()=>{
    dispatch(setGameBetUnlock());
  },
  addGamePoints: data=>{
    dispatch(addGamePoints(data));
  },
  reduceGamePoints: data=>{
    dispatch(reduceGamePoints(data));
  },
  setGamePoints: data => {
    dispatch(setGamePoints(data));
  },
  setGameWonStatus: ()=>{
    dispatch(setGameWonStatus());
  },
  setGameLostStatus: ()=>{
    dispatch(setGameLostStatus());
  },
  setGameActiveStatus: ()=>{
    dispatch(setGameActiveStatus());
  },
  setGameInactiveStatus: ()=>{
    dispatch(setGameInactiveStatus());
  },
  setGameQuitStatus: ()=>{
    dispatch(setGameQuitStatus());
  },
  setGameStartStatus: ()=>{
    dispatch(setGameStartStatus());
  },
  setGameReplayStatus: ()=>{
    dispatch(setGameReplayStatus());
  },
  setGameCorrectAnswerStatus: ()=>{
    dispatch(setGameCorrectAnswerStatus());
  },
  setGameIncorrectAnswerStatus: ()=>{
    dispatch(setGameIncorrectAnswerStatus());
  },
  setGameRevealAllAnswersStatus: ()=>{
    dispatch(setGameRevealAllAnswersStatus());
  },
  resetGameStatus: data=>{
    dispatch(resetGameStatus(data));
  },
  setGameDataIndex: data=> {
    dispatch(setGameDataIndex(data))
  }
});

GameContainer.propTypes = {
  // quizQuestions: PropTypes.array.isRequired,
  // showAnswer: PropTypes.bool.isRequired,
  // index: PropTypes.number.isRequired,
  // onAnswerSelected: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GameContainer);
